import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ActionLink from '@adsk/dh-akn-react-components/es/components/ActionLink';

import {Container, Table} from 'components';
import * as utils from 'utils';

import styles from './AccordionTable.module.scss';
import Context from '../../context';
import {Accordion, IconsProducts} from './components';
import {TYPE_PHYSICAL} from '../../constants';

const handleClickCellGroupName = e => {
  e.currentTarget.parentElement.parentElement.parentElement
    .querySelectorAll('.rt-expandable')[0]
    .click();
};

const columns = [
  {
    Header: 'Group Name',
    accessor: 'groupName',
    className: cn(styles.cell, styles.cellGroupName),
    headerClassName: cn(styles.cellHeader, styles.cellGroupName),
    // eslint-disable-next-line react/prop-types,react/display-name
    Cell: ({value, original: {primaryType, physical, virtual}}) => (
      <div>
        <div className={styles.groupName} onClick={handleClickCellGroupName}>
          {value}
        </div>
        <div>{primaryType === TYPE_PHYSICAL ? physical : virtual}</div>
      </div>
    ),
  },
  {
    Header: 'Products',
    accessor: 'products',
    className: cn(styles.cell, styles.cellProducts),
    headerClassName: cn(styles.cellHeader, styles.cellProducts),
    // eslint-disable-next-line react/display-name
    Cell: row => <IconsProducts icons={row.value} />,
  },
  {
    Header: 'Connect',
    accessor: 'link',
    className: cn(styles.cell, styles.cellConnect),
    headerClassName: cn(styles.cellHeader, styles.cellConnect),
    // eslint-disable-next-line react/prop-types,react/display-name
    Cell: ({value, original: {groupId}}) => (
      <div className={styles.linkVisitGroupPage}>
        <a
          key={value}
          target="_blank"
          rel="noopener noreferrer"
          href={value || '#'}
        >
          <ActionLink label={<>
            <span className={styles.hideOnMobile}>Visit group page</span>
            <span className={styles.visibleOnMobile}>Visit group</span>
          </>} onClickHandler={() => {
            // Tracking Analytics
            utils.handleAnalytics('groupPageVisit', groupId);
          }} />
        </a>
      </div>
    ),
  },
];

export const AccordionTable = ({viewAll, inModal}) => {
  const {dataTable, loading} = useContext(Context);

  return (
    <Container>
      <Table
        className={cn(styles.table, {[styles.inModal]: inModal})}
        pageSize={viewAll ? dataTable.length : 15}
        columns={columns.map(item => ({
          ...item,
          sortable: false,
          show: !(item.accessor === 'products' && inModal),
        }))}
        data={viewAll ? dataTable : dataTable.slice(0, 10)}
        loading={loading}
        minRows={1}
        accordion={row => (
          <Accordion key={row.index} {...row.original} inModal={inModal} />
        )}
      />
    </Container>
  );
};

AccordionTable.propTypes = {
  inModal: PropTypes.bool,
  viewAll: PropTypes.bool,
};

AccordionTable.defaultProps = {
  inModal: false,
  viewAll: false,
};
